import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoiIntlMakePaymentAuthApiActions = createActionGroup({
  source: 'Make Payment Intl - Auth API',
  events: {
    'Load User Success': emptyProps(),
    'Load User Error': props<{ error: HttpErrorResponse }>(),
  },
});
